import { storage } from './storage.js';

/* Restablecer la app en este aparato: borra proveedores, favoritos, progreso, espectadores, ajustes, catálogo guardado, caché y
   descargas, y vuelve a la bienvenida. Se CONSERVA lo de la licencia y los cupos gratuitos (si no, restablecer serviría para
   reiniciar los cupos o gastaría una plaza de la clave al activarla de nuevo). */

export const KEEP = ['installId', 'freeUsed', 'licenseAdopt', 'licenseChecked', 'licenseDevices', 'licenseKey', 'licenseKeyHint', 'licenseLost', 'licenseSeen', 'licenseToken'];

/** Lo que se guarda aparte antes de limpiar: { clave: valor } solo de las claves que existen. */
export function snapshotKept(store = storage, keys = KEEP) {
    const out = {};
    keys.forEach((k) => { const v = store.get(k, undefined); if (v !== undefined && v !== null) out[k] = v; });
    return out;
}

const withTimeout = (p, ms) => Promise.race([p, new Promise((resolve) => setTimeout(resolve, ms))]);

async function deleteDatabases() {
    if (typeof indexedDB === 'undefined') return;
    let names = ['filoteca'];
    try { if (indexedDB.databases) names = Array.from(new Set(names.concat((await indexedDB.databases()).map((d) => d.name).filter(Boolean)))); } catch (e) { /* sin listado */ }
    await Promise.all(names.map((name) => withTimeout(new Promise((resolve) => {
        try {
            const req = indexedDB.deleteDatabase(name);
            req.onsuccess = req.onerror = req.onblocked = () => resolve();
        } catch (e) { resolve(); }
    }), 3000)));
}

/**
 * Hace el restablecimiento. `offline` (opcional) es el gestor de descargas para quitar también lo bajado.
 * Con `reload: false` no recarga la página (para las pruebas).
 */
export async function factoryReset({ offline = null, reload = true, keep = KEEP } = {}) {
    try {
        if (offline && typeof offline.list === 'function') for (const rec of offline.list().slice()) { try { await offline.remove(rec.key); } catch (e) { /* un fichero que no se deja quitar no frena el resto */ } }
    } catch (e) { /* sin descargas */ }
    const kept = snapshotKept(storage, keep);
    try { localStorage.clear(); } catch (e) { /* sin almacenamiento */ }
    try { sessionStorage.clear(); } catch (e) { /* idem */ }
    Object.keys(kept).forEach((k) => storage.set(k, kept[k]));
    await deleteDatabases();
    try { if (typeof caches !== 'undefined') for (const k of await caches.keys()) await caches.delete(k); } catch (e) { /* sin caché */ }
    try { if (navigator.serviceWorker && navigator.serviceWorker.getRegistrations) for (const r of await navigator.serviceWorker.getRegistrations()) await r.unregister(); } catch (e) { /* sin service worker */ }
    if (reload && typeof location !== 'undefined') {
        try { if (window.app && window.app.views && window.app.views.main) window.app.views.main.router.navigate('/', { reloadAll: true, clearPreviousHistory: true }); } catch (e) { /* ya se recarga */ }
        setTimeout(() => location.reload(), 150);
    }
    return { kept: Object.keys(kept) };
}
